import { positioningPriorities } from './positioning-priorities';
import { positioningLogic } from './positioning-logic';
/**
 * Returns whether one rectangle fits in another.
 */
function canRectFit(inner, outer) {
    return (inner.left >= outer.left &&
        inner.top >= outer.top &&
        inner.left + inner.width <= outer.left + outer.width &&
        inner.top + inner.height <= outer.top + outer.height);
}
/**
 * A functions that returns the correct popover position based on screen dimensions.
 */
export function calculatePosition(preferred, trigger, popover, container, viewport) {
    var bestPositionOutsideViewport = null;
    // Attempt to position the popover based on the priority list for this position,
    // trying to fit it inside the container first, and inside the viewport if possible.
    for (var _i = 0, _a = positioningPriorities[preferred]; _i < _a.length; _i++) {
        var actualPosition = _a[_i];
        var boundingOffset = positioningLogic[actualPosition](popover, trigger, container);
        var fitsInContainer = canRectFit(boundingOffset, container);
        var fitsInViewport = canRectFit(boundingOffset, viewport);
        if (fitsInContainer && fitsInViewport) {
            return { actualPosition: actualPosition, boundingOffset: boundingOffset };
        }
        else if (fitsInContainer && bestPositionOutsideViewport === null) {
            bestPositionOutsideViewport = { actualPosition: actualPosition, boundingOffset: boundingOffset };
        }
    }
    // Position it in the best position outside the viewport. The user will need to scroll to view
    // the contents, but at least it's accessible once they do.
    // TODO: one potential improvement would be to calculate how much of the popover is actually
    //   visible in each position and choose the best one based on that
    if (bestPositionOutsideViewport !== null) {
        return bestPositionOutsideViewport;
    }
    // Resort to right-top. This makes the page expand awkwardly past the body's size, but at least
    // it'll be reachable.
    return {
        actualPosition: 'right-top',
        boundingOffset: positioningLogic['right-top'](popover, trigger, container)
    };
}
//# sourceMappingURL=calculate-position.js.map